import React from "react";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";

const PresentationContainer = styled.div`
  background-color: ${({ theme }) => theme.backgroundColor};
  width: 100%;
  display: flex;
  overflow: hidden;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SlideInLeftPanel = styled.div<{ $inView: boolean }>`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
  transform: ${({ $inView }) => ($inView ? "translateX(0%)" : "translateX(-100%)")};
  opacity: ${({ $inView }) => ($inView ? 1 : 0)};
  transition: transform 1s ease, opacity 1s ease;

  img {
    margin-right: 5rem;
  }

  @media (max-width: 768px) {
    width: 100vw;
    justify-content: left;
    img {
      margin-left: 0rem;
    }
  }
`;

const SlideInRightPanel = styled.div<{ $inView: boolean }>`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  transform: ${({ $inView }) => ($inView ? "translateX(0%)" : "translateX(100%)")};
  opacity: ${({ $inView }) => ($inView ? 1 : 0)};
  transition: transform 1s ease, opacity 1s ease;

  img {
    margin-left: 5rem;
  }

  @media (max-width: 768px) {
    width: 100vw;
    justify-content: center;

    img {
      margin-left: 0rem;
    }
  }
`;

type MyComponentProps = {
  LeftSide: React.ReactNode;
  RightSide: React.ReactNode;
};

const LeftRightSlideContainer: React.FC<MyComponentProps> = ({
  LeftSide,
  RightSide,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <PresentationContainer ref={ref}>
      <SlideInLeftPanel $inView={inView}>{LeftSide}</SlideInLeftPanel>
      <SlideInRightPanel $inView={inView}>{RightSide}</SlideInRightPanel>
    </PresentationContainer>
  );
};

export default LeftRightSlideContainer;
